import React, { useEffect } from "react";
import AboutUsPage from "./MeetTheMembersPage";
import ContactComponent from "../minicomponents/ContactComponent";
import { useTranslation, Trans } from "react-i18next"; // Trans import is correct
import ContactInfoBlock from "../minicomponents/ContactInfoBlock";
import { useLocation } from "react-router-dom";
import Footer from "../minicomponents/Footer";
import { Link } from "react-router-dom";
import NewAlbumModal from "../minicomponents/NewAlbumModal";


function AboutPage() {
  const { t } = useTranslation();
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth" });
        }, 100);
      }
    } else if (location.pathname === "/home" || location.pathname === "/about") {
      const element = document.getElementById("home");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.gofundme.com/static/js/embed.js";
    script.defer = true;
    document.body.appendChild(script);

    // Ruim het script netjes op als de gebruiker de pagina verlaat
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="text-white md:py-8" id="about">
      <NewAlbumModal t={t}/>

      <div className=" bg-gray-900 absolute inset-x-0">
        <h1
          className="alt-font text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-8 text-center text-white pt-12"
          style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.15)" }}
        >
          {t("about.header", "About LiveTheWill")}
        </h1>
        <div className="lg:mx-auto lg:max-w-8xl px-6 md:px-12 xl:px-32 py-24 flex flex-col lg:flex-row gap-6">
          <div>
            <section className="mb-10 md:mb-12">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 ">
                {t("about.h1", "Our Calling")}
              </h2>
              <p className="text-lg md:text-xl leading-relaxed text-slate-400 mb-4">
                <Trans
                  i18nKey="about.h1p_combined"
                  defaults="We are <1>LiveTheWill</1> - a group united by a shared purpose: to craft and perform music that radiates <3>faith</3>, ignites <5>hope</5>, and spreads <7>love</7>. Our journey and our songs are guided by a desire to live according to God's will."
                  components={{
                    1: <span className="font-semibold text-white" />,
                    3: <span className="font-semibold" />,
                    5: <span className="font-semibold" />,
                    7: <span className="font-semibold" />,
                  }}
                />
              </p>
              <p className="text-lg md:text-xl leading-relaxed text-slate-400 italic">
                <Trans
                  i18nKey="about.h1p3_combined"
                  defaults="Our deepest inspiration comes from <1>1 Peter 4:1-11</1>, reminding us to use the unique gifts God has given each of us to serve others, so that in all things, He may be praised through Jesus Christ."
                  components={{
                    1: (
                      // eslint-disable-next-line jsx-a11y/anchor-has-content
                      <a
                        href="https://www.biblica.com/bible/niv/1-peter/4/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline hover:text-black transition-colors duration-200 font-medium not-italic"
                      />
                    ),
                  }}
                />
              </p>
            </section>
            <section className="mb-10 md:mb-12">
              <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">
                {t("about.h2", "The Music")}
              </h2>
              <p className="text-lg md:text-xl leading-relaxed text-slate-400">
                {t(
                  "about.h2p",
                  "Through heartfelt melodies and lyrics rooted in scripture and personal testimony, we aim to create music that resonates with the soul, encourages believers, and reaches those seeking connection and truth. Every note is an offering, every performance an act of worship."
                )}
              </p>
            </section>
          </div>
          <div>
          <section className="mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 ">
              {t("about.h3", "Our Rhythm & Connection")}
            </h2>
            <p className="text-lg md:text-xl leading-relaxed text-slate-400 mb-4">
              <Trans
                i18nKey="about.h3p"
                defaults="The heart of our collaboration beats strongest during our weekly rehearsals every <1>Wednesday</1>. It's a dedicated time for prayer, creativity, refining our sound, and strengthening our fellowship as we prepare to share our music."
                components={{ 1: <span className="font-semibold" /> }}
              />
            </p>
            <p className="text-lg md:text-xl leading-relaxed text-slate-400">
              <Trans
                i18nKey="about.h3p2"
                defaults="We love sharing our journey with you! You can find us posting updates, behind-the-scenes moments, and words of encouragement <1>twice a week</1> on our Instagram page. Follow along and connect with us: <3>@LiveTheWill</3>."
                components={{
                  1: <span className="font-semibold" />,
                  3: (
                    // eslint-disable-next-line jsx-a11y/anchor-has-content
                    <a
                      href="https://www.instagram.com/LiveTheWill"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="underline hover:text-white transition-colors duration-200 font-semibold"
                    />
                  ),
                }}
              />
            </p>
          </section>
          
          <section className="mb-10 md:mb-12">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">
              {t("about.h5", "Kerkband Huren voor jouw Dienst?")}
            </h2>
            <p className="text-lg md:text-xl leading-relaxed text-slate-400">
              <Trans
                i18nKey="about.h5p"
                defaults="Looking to book a band? You can <1>hire</1> LiveTheWill as your church band for services, weddings, or conferences."
                components={{ 1: <Link to="/home#contact" className="font-semibold text-white" /> }}
              />
            </p>
          </section>
          
          </div>
          <section>
              <div className="">
                <span className="inline-block bg-amber-500/10 text-amber-400 border border-amber-500/20 px-3 py-1 rounded-full text-xs font-mono tracking-widest uppercase mb-4">
                  {t("support.badge", "Support us")}
                </span>
                <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">
                  {t("support.title", "Build our music together")}
                </h2>
                <p className="text-lg md:text-xl leading-relaxed text-slate-400">
                  {t("support.description", "Would you like to help us continue sharing stories of hope and faith, and make new studio recordings possible? Any donation via our GoFundMe helps us tremendously to keep doing this work!")}
                </p>
              </div>
            
              <a 
                href="https://www.gofundme.com/f/steun-livethewill-met-maken-en-spelen-van-nieuwe-muziek"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-white text-black font-bold py-3 px-6 mt-6 rounded-full hover:bg-slate-200 transition-all text-center shadow-md transform hover:scale-[1.02]"
              >
                {t("support.button", "Support us via GoFundMe 🙏")}
              </a>
          </section>

        </div>


        <div className="bg-gray-800">
          <AboutUsPage t={t} />
        </div>
        
        <div className="px-6" id="contact">
          <h1
            className="alt-font text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-8 text-center text-white pt-12 px-6"
            style={{ textShadow: "1px 1px 3px rgba(0,0,0,0.15)" }}
          >
            {t("contact.title", "Booking/Contact us")}
          </h1>
          <h2 className="text-xl text-center mb-4 text-gray-300 px-6">
            {t("contact.subtitle", "Wil je onze kerkband huren of inhuren? Neem contact op voor de mogelijkheden.")}          </h2>
          <div className="md:mx-auto md:max-w-[120rem] px-6 md:px-32 py-24 flex flex-col justify-center lg:flex-row gap-24">
            <ContactComponent />
            <ContactInfoBlock />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default AboutPage;
